// extracted by mini-css-extract-plugin
module.exports = {"day":"AccountInformation_day__2T-_x","td":"AccountInformation_td__fWSNQ"};